import { loader } from "./actions.tsx";
import SignSinglePage from "./validate.tsx";

export default {
  path: "/link/single/:linkCode",
  loader,
  Component: SignSinglePage,
};
